window.theme = window.theme || {};
window.custom = window.custom || {};
window.Shopify = window.Shopify || {};

(function(){
  /*============================================================================
    Monkey Patches & Extensions
  ==============================================================================*/
  theme.Collection.prototype.forceReload = function() {
    // update the container
    this.container = document.querySelector('[data-section-type="' + this.type + '"]');

    this.init();
  }

  theme.cart.addItem = function(variantId, quantity = 1) {
    return this._updateCart({
      url: ''.concat(theme.routes.cartAdd, '?t=').concat(Date.now()),
      data: JSON.stringify({
        items: [
          {
            quantity: quantity,
            id: variantId,
          }
        ]
      }),
    });
  };

  theme.cart.addMultipleItems = function(newItems = []) {
    return this._updateCart({
      url: ''.concat(theme.routes.cartAdd, '?t=').concat(Date.now()),
      data: JSON.stringify({
        items: newItems
      }),
    });
  };
  
  theme.cart.updateItemsByIndexes = function(qtyArray) {
    return this._updateCart({
      url: ''.concat(theme.routes.cartUpdate, '?t=').concat(Date.now()),
      data: JSON.stringify({
        updates: qtyArray
      })
    })
  };
  theme.CartForm.prototype.initQtySelectors = function() {
    var selectors = {
      qtySelector: '.js-qty__wrapper',
    };

    this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
      var selector = new custom.QtySelector(el, {
        namespace: this.namespace
      });
    });
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();

    document.dispatchEvent(new CustomEvent('reinitProductGridItem'));
  };

  theme.ExtendedNavDrawer = function(id, name) {
    this.bindToggle(id, name);
    theme.Drawers.call(this, id, name);
  };

  // Inherit the prototype of the parent module
  theme.ExtendedNavDrawer.prototype = Object.create(theme.Drawers.prototype);
  theme.ExtendedNavDrawer.prototype.open = function(evt, returnFocusEl) {
    let topHeader     = document.getElementById('SiteHeader');
    let topHeaderRect = topHeader.getBoundingClientRect();
    let navDrawer     = document.getElementById('NavDrawer');

    navDrawer.style.top = topHeaderRect.top + topHeader.offsetHeight + 'px';

    document.documentElement.classList.add(
      `js-drawer-id-${this.config.id.toLowerCase()}`
    );

    document.documentElement.classList.add('lock-scroll');
    theme.Drawers.prototype.open.call(this, evt, returnFocusEl);
    document.documentElement.classList.remove(this.config.openClass);
    window.off('click' + this.config.namespace);
  };

  // Override the original close method
  theme.ExtendedNavDrawer.prototype.close = function(evt, returnFocusEl) {
    document.documentElement.classList.remove(
      `js-drawer-id-${this.config.id.toLowerCase()}`
    );
    theme.Drawers.prototype.close.call(this, evt, returnFocusEl);
  };

  theme.ExtendedNavDrawer.prototype.bindToggle = function(id, name) {
    let self = this;
    let toggleButton = document.querySelector( `.js-drawer-toggle-${name}` );

    toggleButton.addEventListener('click', function() {
      self.isOpen
        ? (this.classList.remove('open'), self.close())
        : (this.classList.add('open'), self.open());
    });

    // Close navigation drawer when resizing to desktop.
    window.addEventListener('resize', function() {
      setTimeout(function() {
        if( window.innerWidth >= 769 )
          self.close();
          toggleButton.classList.remove('open');
      }, 500);
    });
  };

  theme.NavDrawer = new theme.ExtendedNavDrawer('NavDrawer', 'nav');

  /*============================================================================
    Utilities
  ==============================================================================*/
  custom.product = {
    /**
     * Get product by handle
     */
    getProduct: function(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(response) {return response.json()});
    },
  };

  custom.utils = {
    /**
     * numberCast - converts number strings to numbers
     *
     * @param  {string} string a string you want to check
     * @return {number/string} if the argument was a number/number-string, it will be converted to a number. Otherwise it will jsut be returned.
     */
    numberCast: function(string) {
      if (!isNaN(string)) {
        return Number(string);
      }
      return string;
    },
  };

  custom.swym = {
    swymProductView: function(product) {
      ['SwymViewProducts', 'SwymWatchProducts', 'SwymProductVariants'].forEach(function(k){
        if(!window[k]) window[k] = {};
      });
      (function(et){
        var collections = product.type;
        var o={},
        empi=product.id,
        piu = product.featured_image;
        var currentVariant = product.variants[0];

        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];

          SwymProductVariants[variant.id] = {
            empi: empi,
            epi: variant.id,
            du: `${location.origin}${product.url}`,
            dt: product.title,
            ct: collections,
            iu: piu,
            stk: 0,
            pr: variant.price / 100,
            variants: [{}]
          };

          SwymProductVariants[variant.id].variants[0][variant.title] = variant.id ;

          SwymWatchProducts[variant.id] = o[variant.id] = {
            "id": variant.id,
            "available": variant.available,
            "inventory_management": "shopify",
            "inventory_quantity": 0,
            "title": variant.title,
            "inventory_policy": "continue",
          };
        }

        var product_data = {
          empi: empi,
          epi: currentVariant.id,
          dt: product.title,
          du: `${location.origin}${product.url}`,
          ct: collections,
          pr: currentVariant.price / 100,
          stk: 0,
          iu: piu,
          variants:[{}],
        };
        product_data.variants[0][currentVariant.title] = currentVariant.id;

        SwymViewProducts[product.handle] = SwymViewProducts[product.id] = product_data;
        SwymWatchProducts[product.handle] = SwymWatchProducts[product.id] = o;
      })();
    },
  };

  /*============================================================================
    Reusable Classes
  ==============================================================================*/
  custom.PaintCoverage = (function() {
    let selectors = {
      coverage: '.cart__item-coverage-display',
    };

    function PaintCoverage(el, qty) {
      if (!el) { return; }

      this.wrapper     = el;
      this.quantity    = qty
      this.coverageEls = this.wrapper.querySelectorAll(selectors.coverage);

      this.updateCoverage();
    }

    PaintCoverage.prototype = Object.assign({}, PaintCoverage.prototype, {

      updateCoverage: function () {
        this.coverageEls.forEach(function(el) {
          let quantityEl = el.querySelector('span[data-qty]');
          let pluralEl   = el.querySelector('span[data-type]');
          let minEl      = el.querySelector('span[data-coverage-min]');
          let maxEl      = el.querySelector('span[data-coverage-max]');
          let selVar = document.querySelector(`input[name="Size"][value="${pluralEl.getAttribute('data-type')}"]`);
              
          quantityEl.textContent = this.quantity;
          pluralEl.textContent   = `${pluralEl.getAttribute('data-type')}${this.quantity > 1 ? 's' : ''}`;
          minEl.textContent      = parseInt(minEl.getAttribute('data-coverage-min')) * this.quantity;
          maxEl.textContent      = parseInt(maxEl.getAttribute('data-coverage-max')) * this.quantity;

          // Hide/Show based on selected type.
          el.classList.toggle('hide', selVar && !selVar.checked);
        }.bind(this));
      },
    });

    return PaintCoverage;
  })();

  custom.CollectionItemQuickAdd = (function () {
    var classes = {
      hide: 'hide',
      multipleVariants: 'grid-product__multiple-variants',
    };

    function CollectionItemQuickAdd(form) {
      this.form = form;
      this.quickAddHandle = this.form.dataset.quickAddHandle;
      this.isBundle = this.form.dataset.isBundle;
      this.hasOnlyDefaultVariant = null;

      this.init();
    }

    CollectionItemQuickAdd.prototype = Object.assign({}, CollectionItemQuickAdd.prototype, {
      createInput: function(name, value) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', name);
        input.setAttribute('value', value);

        return input;
      },

      initQuickAddForm: function(product) {
        this.hasOnlyDefaultVariant = product.variants.length === 1;

        if (this.hasOnlyDefaultVariant) {

          if (this.isBundle === 'true') {
            var variant = product.variants[0];
            var bundleId = '' + Date.now() + variant.id; // string cast
            var sku = variant.sku;
            var skuStripped = sku.replace(/ /g, '');
            var bundleHandleArray = skuStripped.split(',');
            var promiseArray = [];

            for (var i = 0; i < bundleHandleArray.length; i++) {
              var bundleHandle = bundleHandleArray[i];

              promiseArray.push(
                custom.product.getProduct(bundleHandle)
              );
            }

            Promise.all(promiseArray).then((products) => {
              // when all the promises are resolved
              for (var i = 0; i < products.length; i++) {
                var product = products[i];
                // add hidden id input field for first variant (these prods shouldn't have variants)
                this.form.appendChild(this.createInput('id[]', product.variants[0].id));
              }

              // parent product
              this.form.appendChild(this.createInput('id[]', variant.id));

              // bundle data
              this.form.appendChild(this.createInput('properties[_Bundle ID]', bundleId));
              this.form.appendChild(this.createInput('properties[_Bundle Parent ID]', variant.id));

              // use ajax to submit the form
              new theme.AjaxProduct(this.form);

              this.form.classList.remove(classes.hide);
            });

          } else {
            // add hidden id input field
            this.form.appendChild(this.createInput('id', product.variants[0].id));

            // use ajax to submit the form
            new theme.AjaxProduct(this.form);

            this.form.classList.remove(classes.hide);
          }
        } else {
          // form remains hidden, so style the other button differently
          this.form.parentNode.classList.add(classes.multipleVariants);
        }
      },

      init: function () {
        custom.product.getProduct(this.quickAddHandle).then(
          this.initQuickAddForm.bind(this)
        );
      },
    });

    return CollectionItemQuickAdd;
  })();

  /**
   * custom.QtySelector - overwrites theme.QtySelector so that we can add custom
   * bundle functionality
   */
  custom.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
      this.isBundle = this.wrapper.classList.contains('js-bundle-qty__wrapper');

      var defaults = {
        namespace: null,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();

          if (this.isBundle) {
            this._changeBundle(qty + 1);
          } else {
            this._change(qty + 1);
          }
        }.bind(this));

        this.minus.addEventListener('click', function() {
          var qty = this._getQty();

          if (this.isBundle) {
            this._changeBundle(qty - 1);
          } else {
            this._change(qty - 1);
          }
        }.bind(this));

        this.input.addEventListener('change', function(evt) {
          if (this.isBundle) {
            this._changeBundle(this._getQty());
          } else {
            this._change(this._getQty());
          }
        }.bind(this));
      },

      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
          detail: [this.options.key, qty]
        }));
      },

      _changeBundle: function(qty) {
        // get cart
        theme.cart.getCart().then(function(cart) {
          var cartItems = cart.items;
          var currentBundleId = null;
          var currentBundleQty = null;
          var qtyArray = [];

          // iterate through every cart item
          for (var i = 0; i < cartItems.length; i++) {
            var cartItem = cartItems[i];

            if (
              cartItem.key === this.options.key && // if this is the line item we clicked
              cartItem.properties && // and if it has properties
              cartItem.properties["_Bundle ID"] && // and if it is part of a bundle
              cartItem.properties["_Bundle Parent ID"] == cartItem.id // and if it is a parent item
            ) {
              // user updated a bundle parent's quantity
              // update the stored current bundle data
              currentBundleId = cartItem.properties["_Bundle ID"];
              currentBundleQty = qty;
            }

            if (
              cartItem.properties && // if it has properties
              cartItem.properties["_Bundle ID"] && // and if it is part of a bundle
              cartItem.properties["_Bundle ID"] == currentBundleId // and if it is part of the clicked bundle
            ) {
              // NOTE: when using cartItem.quantity there are some race conditions. the safest number to use is currentBundleQty, which is pulled from the event
              // push the item's current quantity to the array
              qtyArray.push(currentBundleQty);

            } else {
              // push the item's current quantity to the array
              qtyArray.push(cartItem.quantity);
            }
          } // end for

          // update quantities and rebuild cart
          theme.cart.updateItemsByIndexes(qtyArray)
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:build'));

            return cart;
          })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          });
        }.bind(this));
      }
    });

    return QtySelector;
  })();

  custom.RecommendationsSlider = (function () {
    function RecommendationsSlider(container) { this.init(container);}

    RecommendationsSlider.prototype = Object.assign(
      {},
      RecommendationsSlider.prototype,
      {
        classes: {
          sliderEl  : 'product-recommendations__slider',
          filterAttr: 'data-recommendation-filter',
          slideAttr : 'data-recommendation-type'
        },
        sliderConfig: {
          adaptiveHeight : false,
          pageDots       : false,
          prevNextButtons: false,
          wrapAround     : false,
          draggable      : true,
          initialIndex   : 0,
          freeScroll     : true,
          groupCells     : '80%',
          cellAlign      : 'left',
        },

        init: function (container) {
          let self = this;
          self.container = container;
          self.createSlideshow();
          self.registerEventListeners();
          window.pSlider = this;
        },

        createSlideshow: function() {
          let self = this;

          self.sliderEl = self.container.querySelector(
            `.${this.classes.sliderEl}.active-slider`
          );

          if (!self.sliderEl) { return; }

          if(window.innerWidth <= 768) {
            self.slideshow = new Flickity(self.sliderEl, self.sliderConfig);
          }
        },

        hasInheritedProperty: function(obj, property) {
          return obj !== undefined && typeof obj === 'object' && obj !== null 
            && property in obj && !obj.hasOwnProperty(property);
        },

        registerEventListeners: function() {
          let self = this;

          window.addEventListener('resize', function() {
            self.container.style.height = '';
            if(window.innerWidth >= 768 && self.hasInheritedProperty(self.slideshow, 'destroy')) {
              self.slideshow.destroy(); self.slideshow = false;
            } else if(self.hasInheritedProperty(self.slideshow, 'resize')) {
              self.slideshow.resize();
            } else{
              self.createSlideshow();
            }
          });

          window.addEventListener('click', function(e) {
            if (e.target.hasAttribute(self.classes.filterAttr)) {
              self.container.style.height = self.container.offsetHeight + 'px';
              const activeFilter = e.target.getAttribute(self.classes.filterAttr);
              const allFilters   = document.querySelectorAll(
                `li[${self.classes.filterAttr}]`
              );
              const recoSliders = document.querySelectorAll(
                `div[${self.classes.slideAttr}]`
              );
        
              allFilters.forEach(el => {
                el.classList.toggle('active', el == e.target);
              });

              recoSliders.forEach(s => {
                const slideFilter = s.getAttribute(self.classes.slideAttr);
                s.classList.toggle('active-slider', slideFilter === activeFilter);
              });

              if(self.hasInheritedProperty(self.slideshow, 'destroy')) {
                self.slideshow.destroy(); self.slideshow = false;
              }

              self.createSlideshow();
            }
          });
        }
      }
    );

    return RecommendationsSlider;
  })();
  
  custom.ProductSlider = (function () {
    const classes = {
      sliderWrapper: 'product-slider',
      nextPrevButton: 'flickity-button',
      buttonsWrapper: 'product-slider-buttons',
    };
    const selectors = {
      sliderWrapper: '.' + classes.sliderWrapper,
      nextPrevButton: '.' + classes.nextPrevButton,
      buttonsWrapper: '.' + classes.buttonsWrapper,
    };
    const defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
    };
    function ProductSlider(container) {
      this.container = container;
      this.slideshow = container.querySelector(selectors.sliderWrapper);
      if (!this.slideshow) {
        return;
      }
      this.init();
    }

    ProductSlider.prototype = Object.assign({}, ProductSlider.prototype, {
      init: function () {
        if (theme.config.bpSmall) {
          this.createSlideshow();
        }

        document.addEventListener(
          'matchSmall',
          function () {
            this.createSlideshow();
          }.bind(this)
        );

        document.addEventListener(
          'unmatchSmall',
          function () {
            if (this.flickity) {
              this.onUnload();
            }
          }.bind(this)
        );
      },

      createSlideshow: function() {
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
        this.wrapButtons();
      },

      insertAfter: function (referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(
          newNode,
          referenceNode.nextSibling
        );
      },

      wrapButtons: function () {
        const buttons = this.slideshow.querySelectorAll(
          selectors.nextPrevButton
        );
        const parent = this.slideshow.parentNode;
        let buttonWrapper = parent.querySelector(selectors.buttonsWrapper);
        if (!buttonWrapper) {
          buttonWrapper = document.createElement('div');
          buttonWrapper.classList.add(classes.buttonsWrapper);
        }
        buttons.forEach((button) => buttonWrapper.appendChild(button));
        this.insertAfter(this.slideshow, buttonWrapper);
      },

      dewrapButtons: function () {
        const buttonWrapper = this.slideshow.nextSibling;
        const buttons = buttonWrapper.querySelectorAll(
          selectors.nextPrevButton
        );
        buttons.forEach((button) => this.slideshow.appendChild(button));
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.dewrapButtons();
          this.flickity.destroy();
        }
      },
    });

    return ProductSlider;
  })();

  /*============================================================================
    Custom Section Functionality
  ==============================================================================*/
  /**
   * custom.Testimonials - this is a copy from theme.js, with some minor
   * customizations made for our needs
   */
  custom.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      autoPlay: true,
      prevNextButtons: true // this is the only deviation from theme.js so far
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
       /* if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        } */
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Testimonials;
  })();






  custom.TestimonialsAdsPage = (function() {
    var defaults = {
      adaptiveHeight: false,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: true // this is the only deviation from theme.js so far
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
       /* if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        } */
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Testimonials;
  })();


  
 /*============================================================================
    Custom Section Functionality
  ==============================================================================*/
  /**
   * custom.Community - this is a copy from theme.js, with some minor
   * customizations made for our needs
   */
  custom.Community = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true, // this is the only deviation from theme.js so far,
      cellAlign: 'left',
      wrapAround: true
    };

    function Community(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Community-' + sectionId);
      this.namespace = '.community-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Community.prototype = Object.assign({}, Community.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        /* if (this.slideshow.dataset.count > 2) {
           this.timeout = setTimeout(function() {
             this.flickity.goToSlide(1);
           }.bind(this), 1000);
         } */
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Community;
  })();

  /*============================================================================
    Custom Section Functionality
  ==============================================================================*/
  /**
   * custom.Community - this is a copy from theme.js, with some minor
   * customizations made for our needs
   */
  custom.CommunityMobile = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true, // this is the only deviation from theme.js so far,
      cellAlign: 'left',
      wrapAround: true
    };

    function CommunityMobile(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#CommunityMobile-' + sectionId);
      this.namespace = '.community-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    CommunityMobile.prototype = Object.assign({}, CommunityMobile.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        /* if (this.slideshow.dataset.count > 2) {
           this.timeout = setTimeout(function() {
             this.flickity.goToSlide(1);
           }.bind(this), 1000);
         } */
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return CommunityMobile;
  })();

  /*============================================================================
    Custom Section Functionality
  ==============================================================================*/
  /**
   * custom.Founders - this is a copy from theme.js, with some minor
   * customizations made for our needs
   */
  custom.Founders = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true, // this is the only deviation from theme.js so far,
      cellAlign: 'left'
    };

    function Founders(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Founders-' + sectionId);
      this.namespace = '.founders-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Founders.prototype = Object.assign({}, Founders.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        /* if (this.slideshow.dataset.count > 2) {
           this.timeout = setTimeout(function() {
             this.flickity.goToSlide(1);
           }.bind(this), 1000);
         } */
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Founders;
  })();

  custom.Product = (function() {
    var classes = {
      tabActive: 'tab--active',
    };

    var selectors = {
      bundleId: '#bundle-id',
      productTabs: '#product-tabs',
      productTabsContainer: '.product-tabs__container',
      paintCoverage: '.cart__item-coverage',
      tabActive: '.' + classes.tabActive,
    };

    function Product(container) {
      this.container = container;
      this.productTabsContainer = this.container.querySelector(selectors.productTabsContainer);
      this.productTabs = this.container.querySelector(selectors.productTabs);
      this.paintCoverage = this.container.querySelector(selectors.paintCoverage);
      this.qty = 1;

      var sectionId = this.sectionId = container.getAttribute('data-section-id');

      this.ids = {
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
        variantsJson: 'VariantsJson-' + sectionId,
        productPriceButton: 'ProductPriceButton-' + sectionId,
        comparePriceButton: 'ComparePriceButton-' + sectionId,
      };

      this.cache = {
        bundleIdEl: container.querySelector(selectors.bundleId),
      };

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      prefillVariantHeart: function() {
        if (this.currentVariantJson) {
          window.triggerSwymVariantEvent(this.currentVariantObject.id);

          // parent container of the where the button is rendered
          _swat.initializeActionButtons(".product-single__sticky");
        }
      },

      onTabClick: function(event) {
        // check to make sure we are clicking a tab, and not the UL behind it
        if (event.target.nodeName !== 'A') {
          return; // bail
        }

        let activeTabs = this.productTabsContainer.querySelectorAll(
          selectors.tabActive
        );

        // deactivate existing active tab and panel
        activeTabs.forEach(function(tab) {
          tab.classList.remove(classes.tabActive);
        });

        // Add .tab-active to product tabs
        event.target.parentElement.classList.add(classes.tabActive);

        // activate new tab and panel
        document.getElementById(
          event.target.href.split('#!')[1]
        ).classList.add(classes.tabActive);
      },

      updateBundleId: function() {
        if (this.cache.bundleIdEl) {
          this.cache.bundleIdEl.value = Date.now();
        }
      },

      updatePaintCoverage: function() {
        new custom.PaintCoverage(this.paintCoverage, this.qty);
      },

      /**
       * updateButtonPrice - borrowed from updatePrice in theme.js
       */
      updateButtonPrice: function() {
        var productPriceButton = document.getElementById(this.ids.productPriceButton);
        var comparePriceButton = document.getElementById(this.ids.comparePriceButton);
        var swatchInput        = document.querySelector('.js-variant-input--swatch');

        if(swatchInput && swatchInput.checked) {
          console.log('aa',swatchInput)
          productPriceButton.innerHTML = theme.Currency.formatMoney(
            parseInt(swatchInput.getAttribute('data-swatch-price-int')) * this.qty,
            theme.settings.moneyFormat
          );
        } else if(this.currentVariantObject) {
          // Regular price
          productPriceButton.innerHTML = theme.Currency.formatMoney(
            this.currentVariantObject.price * this.qty,
            theme.settings.moneyFormat
          );

          // Sale price, if necessary
          if (this.currentVariantObject.compare_at_price > this.currentVariantObject.price) {
            comparePriceButton.innerHTML = theme.Currency.formatMoney(
              this.currentVariantObject.compare_at_price * this.qty,
              theme.settings.moneyFormat
            );
          }
        }
      },

      changeQuantity: function(e) {
        // update current quantity
        this.qty = e.detail[1];

        this.updatePaintCoverage();
        this.updateButtonPrice(this.qty);
      },

      changeVariant: function(e) {
        // update current variant
        this.currentVariantObject = e.detail.variant;
        this.updatePaintCoverage();
        this.updateButtonPrice(this.qty);
      },

      initEventListeners: function() {
        document.addEventListener('ajaxProduct:added', this.updateBundleId.bind(this));
        document.addEventListener('cart:quantity.product', this.changeQuantity.bind(this));
        document.addEventListener('variant:change', this.changeVariant.bind(this));
      },

      init: function() {
        this.initEventListeners();
        this.updatePaintCoverage();

        this.currentVariantJson = document.getElementById(this.ids.currentVariantJson);

        if (this.currentVariantJson) {
          // if multiple variants
          this.currentVariantObject = JSON.parse(this.currentVariantJson.innerHTML);
        } else {
          // if no variants
          this.variantsJson = document.getElementById(this.ids.variantsJson);
          this.currentVariantObject = JSON.parse(this.variantsJson.innerHTML)[0];
        }

        this.container.querySelectorAll('.js-quick-add-form').forEach(quickAddForm => {
          new theme.AjaxProduct(quickAddForm);
        });

        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }

        window.SwymCallbacks.push(this.prefillVariantHeart.bind(this));

        // this.productTabs.addEventListener('click', this.onTabClick.bind(this), false);
      },
    });

    return Product;
  })();

  custom.Quiz = (function() {
    var selectors = {
      progressBars: '.progressbar',
    };

    function Quiz(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');

      this.cache = {
        progressBars: document.querySelectorAll(selectors.progressBars),
      };

      this.init();
    }

    Quiz.prototype = Object.assign({}, Quiz.prototype, {
      updateProgressBars: function(e) {
        for (var i = 0; i < this.cache.progressBars.length; i++) {
          var progressBar = this.cache.progressBars[i];

          progressBar.ariaValueNow = e.detail.percentage;
          progressBar.value = e.detail.percentage;
        }
      },

      init: function() {
        document.addEventListener(
          'percent:updated',
          this.updateProgressBars.bind(this)
        );
      },
    });

    return Quiz;
  })();


  /*============================================================================
    Recommendations
  ==============================================================================*/
  custom.ProductRecommendations = (function () {
    function ProductRecommendations(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }

    ProductRecommendations.prototype = Object.assign({}, ProductRecommendations.prototype, {
      initProductCards: function() {
        this.container.querySelectorAll('.grid-product').forEach(gridProduct => {
          var handle = gridProduct.dataset.productHandle;
          var productCardUrl = `/products/${handle}?view=card`;
          var productData = `/products/${handle}.js`;

          // smiliar logic to Product.vue
          fetch(productCardUrl)
            .then(function(response) {
              return response.text();
            })
            .then(function(html) {
              // console.log(html);
              gridProduct.innerHTML = html;
            }.bind(this))
            .then(function() {
              // init swym
              fetch(productData)
                .then(function (response) {
                  return response.json();
                })
                .then(function (product) {
                  custom.swym.swymProductView(product);

                  function swymCallbackFn() {
                    // parent container of the where the button is rendered
                    _swat.initializeActionButtons(".grid-product__secondary-image");
                  }

                  if (!window.SwymCallbacks) {
                    window.SwymCallbacks = [];
                  }

                  window.SwymCallbacks.push(swymCallbackFn);
                });

              var quickAddForm = gridProduct.querySelector('.js-quick-add-form');
              new custom.CollectionItemQuickAdd(quickAddForm);
            });
        });
      },

      init: function () {
        // this.initProductCards(); // No longer needed
        this.recommendations = new custom.RecommendationsSlider(this.container);
      },
    });

    return ProductRecommendations;
  })();

  /*============================================================================
    Collections
  ==============================================================================*/
  custom.Collection = (function () {
    function Collection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      initEventListeners: function() {
        document.addEventListener('reinitProductGridItem', this.reinit.bind(this));
      },

      reinit: function () {
        // re-register the whole thing, since the ajax call removes the original section
        theme.sections.register('collection-template', custom.Collection);
      },

      init: function () {
        this.initEventListeners();

        this.container.querySelectorAll('.js-quick-add-form').forEach(quickAddForm => {
          new custom.CollectionItemQuickAdd(quickAddForm);
        });
      },
    });

    return Collection;
  })();

  custom.CollectionRecommendations = (function () {
    function CollectionRecommendations(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }

    CollectionRecommendations.prototype = Object.assign(
      {},
      CollectionRecommendations.prototype,
      {
        init: function () {
          this.recommendations = new custom.ProductSlider(this.container);
        },
      }
    );

    return CollectionRecommendations;
  })();

  custom.HeaderSection = (function() {
    var selectors = {
      cartBubbleQuantity: '#CartBubbleQuantity',
      cartBubbleQuantityDrawer: '#CartBubbleQuantityDrawer',
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.cartBubbleQuantity = this.container.querySelector(selectors.cartBubbleQuantity);
      this.cartBubbleQuantityDrawer = document.querySelector(selectors.cartBubbleQuantityDrawer);
      this.cartQuantity = Number(this.cartBubbleQuantity.innerHTML);

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      setCartQuantity: function(qty) {
        this.cartQuantity = qty;
        this.cartBubbleQuantity.innerHTML = this.cartQuantity;
        this.cartBubbleQuantityDrawer.innerHTML = this.cartQuantity;
      },

      getCartQuantity: function(items) {
        var initialCartQuantity = 0;

        for (var i = 0; i < items.length; i++) {
          var item = items[i];

          // if it's a bundle parent or child
          if (item.properties && item.properties["_Bundle Parent ID"]) {
            var bundleParentId = Number(item.properties["_Bundle Parent ID"]);
            var variantId = item.variant_id;

            if (bundleParentId === variantId) {
              // This is a bundle parent
              initialCartQuantity = initialCartQuantity + item.quantity;
            }
          } else {
            initialCartQuantity = initialCartQuantity + item.quantity;
          }
        }

        return initialCartQuantity;
      },

      init: function() {
        document.addEventListener('cart:updated', function(e) {
          var cart = e.detail.cart;
          var items = cart.items;

          this.setCartQuantity(this.getCartQuantity(items));
        }.bind(this));

        document.addEventListener('cart:build', function() {
          // TODO: combine this with the matching event listeners in the cart module, to prevent duped ajax requests
          theme.cart.getCart().then(function(cart) {
            this.setCartQuantity(this.getCartQuantity(cart.items));
          }.bind(this));
        }.bind(this));

        document.addEventListener('ajaxProduct:added', function() {
          // TODO: combine this with the matching event listeners in the cart module, to prevent duped ajax requests
          theme.cart.getCart().then(function(cart) {
            this.setCartQuantity(this.getCartQuantity(cart.items));
          }.bind(this));
        }.bind(this));
      },
    });

    return HeaderSection;
  })();

  /*============================================================================
    Cart
  ==============================================================================*/
  custom.Cart = (function () {
    var classes = {
      hide: 'hide'
    }

    var selectors = {
      originalTotalPrice: '[data-original-total-price]',
    };

    function Cart(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.cartDrawer = document.querySelector('#CartDrawer');
      this.originalTotalPrice = this.cartDrawer.querySelector(selectors.originalTotalPrice);

      this.selectors = {
        bannerSwatchesOnly: '#banner-swatches-only',
        bannerShippyOnly: '#banner-shippy-only',
        bannerPaintOnly: '#banner-paint-only',
      };

      this.cache = {
        bannerSwatchesOnly: document.querySelector(this.selectors.bannerSwatchesOnly),
        bannerShippyOnly: document.querySelector(this.selectors.bannerShippyOnly),
        bannerPaintOnly: document.querySelector(this.selectors.bannerPaintOnly),
      };

      this.init();
    }

    Cart.prototype = Object.assign({}, Cart.prototype, {
      _isPaint: function(item) {
        var itemTitle = item.title.toLowerCase();
        var itemType = item.product_type.toLowerCase();

        return itemType.indexOf('paint') > -1 || itemTitle.indexOf('primer') > -1 || itemTitle.indexOf('ceiling') > -1;
      },

      _isSwatch: function(item) {
        var itemTitle = item.title.toLowerCase();
        var itemType = item.product_type.toLowerCase();

        return itemType.indexOf('swatch') > -1;
      },

      updateCartState: function (items) {
        // reset cart state
        theme.cartState = {
          paintOnly: true,
          swatchesOnly: true,
        };

        for (var i = 0; i < items.length; i++) {
          var item = items[i];

          // basically filtering the states down
          if (this._isPaint(item)) {
            // if it's paint, can't be swatch only
            theme.cartState.swatchesOnly = false;
          }

          if (this._isSwatch(item)) {
            // if it's a swatch, can't be paint only
            theme.cartState.paintOnly = false;
          }

          if (!this._isPaint(item) && !this._isSwatch(item)) {
            // if it's something else, it can't be paint or swatch only
            theme.cartState.paintOnly = false;
            theme.cartState.swatchesOnly = false;
          }
        }

        // emit an event for Vue to pick up, without worrying about racing
        document.dispatchEvent(new CustomEvent('cartState:updated'));
      },

      updatePaintCoverage: function(e) {
        var key = e.detail[0];
        var qty = e.detail[1];

        var lineItem = this.cartDrawer.querySelector(`.cart__item[data-key="${key}"]`);
        var paintCoverage = lineItem.querySelector('.cart__item-coverage');

        if (paintCoverage) {
          new custom.PaintCoverage(paintCoverage, qty);
        }
      },

      removeLineItems: function(e) {        
        // loop parent nodes from the target to the delegation node
        for (var target = e.target; target && target != this; target = target.parentNode) {
          if (target.matches('.cart__remove')) {
            e.preventDefault();


            // Cart Upsell JS
            setTimeout(() => {              
              const productId = e.target.closest('.cart__item')?.getAttribute('product-id');

              const upsellProduct = document.querySelector(`.cart__upsell-product-wrapper[product-id="${productId}"]`);

              if (upsellProduct) {
                upsellProduct.style.display = 'flex';
              }
            }, 1000)
            // END Cart Upsell JS

            

            // handle URL w/ AJAX
            fetch(target.href).then(function() {              
              document.dispatchEvent(new CustomEvent('cart:build'));
            });

            break;
          }
        }
      },

      showOriginalPrice: function(cart) {
        var discountAmount = 0;
        var originalTotal = 0;

        for (var i = 0; i < cart.items.length; i++) {
          var cartItem = cart.items[i];
          if (!cartItem.properties["_Bundle Parent ID"]) {
            discountAmount = discountAmount + cartItem.total_discount;
          }
        }

        // need to do this math so that we can treat the bundle pricing as pricing, instead of treating it like a discount
        originalTotal = cart.total_price + discountAmount;

        this.originalTotalPrice.innerHTML = theme.Currency.formatMoney(
          originalTotal,
          theme.settings.moneyFormat
        );

        // if a script discount is applied
        if (originalTotal !== cart.total_price) {
          this.originalTotalPrice.classList.remove('hide');
        } else {
          this.originalTotalPrice.classList.add('hide');
        }
      },

      initEventListeners: function() {
        document.addEventListener('cart:updated', function(e) {
          var cart = e.detail.cart;
          var items = cart.items;

          this.updateCartState(items);
          this.showOriginalPrice(cart);
        }.bind(this));

        document.addEventListener(
          'cart:quantity.cart-undefined',
          this.updatePaintCoverage.bind(this)
        );

        document.addEventListener('cart:build', function(e) {
          // get cart and update cart state on load
          theme.cart.getCart().then(function(cart) {
            this.updateCartState(cart.items);
            this.showOriginalPrice(cart);
          }.bind(this));
        }.bind(this));

        document.addEventListener('ajaxProduct:added', function(e) {
          var product = e.detail.product;

          
          // Cart Upsell JS
          const upsellProduct = document.querySelector(`.cart__upsell-product-wrapper[product-id="${product.id}"]`);

          if (upsellProduct) {
            upsellProduct.style.display = 'none';
          }
          // End Cart Upsell JS


          
          // get cart and update cart state
          // NOTE: consider reworking this to not fetch the cart each time
          theme.cart.getCart().then(function(cart) {
            this.updateCartState(cart.items);
            this.showOriginalPrice(cart);
          }.bind(this));
        }.bind(this));

        document.addEventListener('cartState:updated', function() {
          if (theme.cartState.swatchesOnly) {
            this.cache.bannerSwatchesOnly.classList.remove(classes.hide);
            this.cache.bannerShippyOnly.classList.add(classes.hide);
            this.cache.bannerPaintOnly.classList.add(classes.hide);
          } else if (theme.cartState.paintOnly) {
            this.cache.bannerSwatchesOnly.classList.add(classes.hide);
            this.cache.bannerShippyOnly.classList.remove(classes.hide);
            this.cache.bannerPaintOnly.classList.remove(classes.hide);
          } else {
            this.cache.bannerSwatchesOnly.classList.add(classes.hide);
            this.cache.bannerPaintOnly.classList.add(classes.hide);
            this.cache.bannerShippyOnly.classList.add(classes.hide);
          }
        }.bind(this));

        this.cartDrawer.addEventListener('click', this.removeLineItems.bind(this));
      },

      init: function () {
        this.initEventListeners();

        // get cart and update cart state on load
        theme.cart.getCart().then(function(cart) {
          this.updateCartState(cart.items);
          this.showOriginalPrice(cart);
        }.bind(this));
      },
    });

    return Cart;
  })();

  custom.Article = (function() {
    function Article(container) {
      this.container = container;
      console.log(this);
      this.init();
    }

    Article.prototype = Object.assign({}, Article.prototype, {
      init: function() {
        console.log('article');
        this.container.querySelectorAll('.js-quick-add-form').forEach(quickAddForm => {
          new custom.CollectionItemQuickAdd(quickAddForm);
        });
      }
    });

    return Article;
  })();


  /*============================================================================
    Theme Register
  ==============================================================================*/
  theme.sections.register('header', custom.HeaderSection);
  theme.sections.register('header', custom.Cart);
  theme.sections.register('product', custom.Product);
  theme.sections.register('product-recommendations', custom.ProductRecommendations);
  theme.sections.register('quiz-template', custom.Quiz);
  theme.sections.register('collection-template', custom.Collection);
  theme.sections.register(
    'collection-recommendations',
    custom.CollectionRecommendations
  );
  theme.sections.register('testimonials-custom', custom.Testimonials);
  theme.sections.register('testimonials-custom-ads-page', custom.TestimonialsAdsPage);
  theme.sections.register('community-custom', custom.Community);	
  theme.sections.register('community-custom', custom.CommunityMobile);	
  theme.sections.register('founders-custom', custom.Founders);
  theme.sections.register('article-template', custom.Article);
})();

// Flickity Carousel for sections with the class 'fc-carousel'
var fcCarousels = document.querySelectorAll('.fc-carousel');

fcCarousels.forEach(function(elem, index) {
  // Already initialized elsewhere (e.g. the Omega search fallback in theme.js)
  if (Flickity.data(elem)) {
    return;
  }

  // Same behavior as the Omega search no-results carousel (theme.js)
  if (elem.classList.contains('omega-no-results-carousel')) {
    new Flickity(elem, {
      cellAlign: 'left',
      pageDots: false,
      lazyLoad: 4,
      wrapAround: false,
      contain: true,
      groupCells: false,
      draggable: '>1',
      prevNextButtons: !matchMedia('screen and (max-width: 768px)').matches
    });
    return;
  }

  let fcOptions = {
    // options	
    cellAlign: 'left',	
    pageDots: false,	
    lazyLoad: true,	
    wrapAround: true,	
    contain: true	
  };

  // enable prev/next buttons at 768px	
  if (matchMedia('screen and (max-width: 768px)').matches) {	
    fcOptions.prevNextButtons = false;	
  }

  var flkty = new Flickity(elem, fcOptions);
});

// Cart Upsell JS

      document.addEventListener("DOMContentLoaded", function () {
          setTimeout(function () {
              const normalProducts = document.querySelectorAll('.cart__item');

              normalProducts.forEach(function (normalProduct) {
                  const normalProductId = normalProduct.getAttribute('product-id');

                    const upsellProduct = document.querySelector(`.cart__upsell-product-wrapper[product-id="${normalProductId}"]`);

                    if (upsellProduct) {
                      upsellProduct.style.display = 'none';
                    }
              });

            const addToCartButtons = document.querySelectorAll('.cart__upsell-product-action button');

             addToCartButtons.forEach(function (buttonEl) {
                    buttonEl.addEventListener('click', (el) => {
                        const wrapperEl = el.target.closest('.cart__upsell-product-wrapper');
          
                        if (wrapperEl) {
                            wrapperEl.style.display = 'none';
                        }
                    })
              });           
          }, 1000); 
      });

      document.addEventListener('click', (el) => {
        setTimeout(() => {
          const wrapperEl = el.target.closest('.cart__item.hide');

          if (wrapperEl) {            
              const productId = wrapperEl.getAttribute('product-id');

              const upsellProduct = document.querySelector(`.cart__upsell-product-wrapper[product-id="${productId}"]`);

              if (upsellProduct) {
                upsellProduct.style.display = 'flex';
              }
          }          
        }, 500)
      })

// END Cart Upsell JS
// CLP Sale Banner JS 
        var isBannerHiddenInt = sessionStorage.getItem('isBannerHiddenInt');
        if (isBannerHiddenInt === 'true') {
            $('.collection-sale-banner-2-int').hide();
        }
        $('.banner-toggle-int').on('click', function () {
            $('.collection-sale-banner-2-int').toggle();
            var isVisibleInt = $('.collection-sale-banner-2-int').is(':visible');
            sessionStorage.setItem('isBannerHiddenInt', !isVisibleInt);
        });

        var isBannerHiddenExt = sessionStorage.getItem('isBannerHiddenExt');
        if (isBannerHiddenExt === 'true') {
            $('.collection-sale-banner-2-ext').hide();
        }
        $('.banner-toggle-ext').on('click', function () {
            $('.collection-sale-banner-2-ext').toggle();
            var isVisibleExt = $('.collection-sale-banner-2-ext').is(':visible');
            sessionStorage.setItem('isBannerHiddenExt', !isVisibleExt);
        });

        var isBannerHiddenSupl = sessionStorage.getItem('isBannerHiddenSupl');
        if (isBannerHiddenSupl === 'true') {
            $('.collection-sale-banner-2-supl').hide();
        }
        $('.banner-toggle-supl').on('click', function () {
            $('.collection-sale-banner-2-supl').toggle();
            var isVisibleSupl = $('.collection-sale-banner-2-supl').is(':visible');
            sessionStorage.setItem('isBannerHiddenSupl', !isVisibleSupl);
        });
// END CLP Sale Banner JS

      // Swatch variant customization
  document.addEventListener("DOMContentLoaded", function () {
      const swatchRadioWrapper = document.querySelector('.variant-input-wrap[data-handle="size"]');
      const swatchRadioButtonAll = swatchRadioWrapper.querySelectorAll('.variant-input--size');
      const mainEl = document.querySelectorAll('.variant-input-wrap[data-handle="finish"]')[0];
      const swatchRadioButton = swatchRadioWrapper.querySelector('.variant-input--size[data-value="Swatch"]');
      swatchRadioButtonAll.forEach((button) => {
      button.addEventListener('click', (event) => {
      
          if (event.target.value === 'Swatch') {
              document.querySelector('.variant-input--finish[data-value*="Eggshell"] label').click();
      
              mainEl.classList.add('hidden');
              document.querySelector('.span-eggshell-only').classList.remove('hidden');
              let button = document.querySelector("button.add-to-cart");
              isAvailable = event.target.getAttribute('data-swatch-available')
              if(isAvailable == 'true'){
                  if (button) {
                      button.removeAttribute("disabled");
                      button.classList.remove("disabled");
                      // update button text
                      let buttonText = button.querySelector("span[data-default-text]");
                      if (buttonText) {
                          buttonText.textContent = buttonText.getAttribute("data-default-text");
                      }
                  }
                }else{
                  if (button) {
                        button.setAttribute("disabled", "true");
                        button.classList.add("disabled");
                        // update button text
                        var buttonText = button.querySelector("span[data-default-text]");
                        if (buttonText) {
                            buttonText.textContent = 'Sold Out';
                        }
                    }
                }
          } else {
              mainEl.classList.remove('hidden');
              document.querySelector('.span-eggshell-only').classList.add('hidden');
          }
      
      })
      })
  })